import styled, { css } from 'styled-components';

export const CheckActive = styled.div<{
  readonly active?: boolean;
}>`
  max-width: 20px;
  min-width: 20px;
  height: 20px;
  border: 2px solid ${({ theme }) => theme.colors.lightPurple};
  margin-right: 12px;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  transition: 0.3s ease border-color;
  &::after {
    position: absolute;
    content: '';
    width: 12px;
    height: 12px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-color: transparent;
  }
`;
export const Card = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.lightPurple};
  max-width: 105px;
  min-width: 105px;
  border-radius: 4px;
  transition: 0.3s ease all;
  display: flex;
  position: relative;
  align-items: center;
  height: 54px;
  transition: 0.3s ease border-color;
`;
export const PaymentMethodCardWrapper = styled.label<{ readonly isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  position: relative;
  cursor: pointer;
  user-select: none;
  &:hover {
    ${CheckActive} {
      border-color: ${({ theme }) => theme.colors.cartCountColor};
    }
    ${Card} {
      border-color: ${({ theme }) => theme.colors.cartCountColor};
    }
  }
  input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    &:checked {
      & + ${CheckActive} {
        border-color: ${({ theme }) => theme.colors.cartCountColor};
        &::after {
          background-color: ${({ theme }) => theme.colors.cartCountColor};
        }
        & + ${Card} {
          border-color: ${({ theme }) => theme.colors.cartCountColor};
        }
      }
    }
  }
  transition: 0.3s ease opacity, 0.3s ease border-color;
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      pointer-events: none;
      opacity: 0.7;
    `}
`;
